module.exports = __webpack_public_path__ + "static/media/tcicon.38d7a9c9.ttf";